import Vue from "vue";

Vue.prototype.$rifinitura = [
  {
    key: "rifinitura0"
  },
  {
    key: "rifinitura1"
  },
  {
    key: "rifinitura2"
  }
];
